import React from 'react';
import './DialogBase.css';

function ConfirmDialog({ confirmationDialog, handleConfirmResponse, t }) {
  if (!confirmationDialog) {
    return null;
  }

  return (
    <div
      className="app-confirm-overlay"
      role="alertdialog"
      aria-live="assertive"
      aria-modal="true"
      onClick={() => handleConfirmResponse(false)}
    >
      <div
        className="app-confirm-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="app-dialog-head">
          <p className="app-dialog-label">{t('dialog_confirmation_label')}</p>
        </div>
        <div className="app-confirm-content">
          {confirmationDialog.message.split('\n').map((line, idx) => (
            <p key={`confirm-line-${idx}`}>
              {line}
            </p>
          ))}
        </div>
        <div className="app-dialog-actions app-confirm-actions">
          <button
            type="button"
            className="app-confirm-btn secondary"
            onClick={() => handleConfirmResponse(false)}
          >
            {t('dialog_cancel')}
          </button>
          <button
            type="button"
            className="app-confirm-btn primary"
            onClick={() => handleConfirmResponse(true)}
          >
            {t('dialog_continue')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
